const webRoot = window.resourceBaseUrl;
__webpack_public_path__ = `${webRoot || ''}/dtale/static/dist/`;
